module.exports = __webpack_public_path__ + "static/img/5a.00a54f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/5a.jpg
// module id = vsOG
// module chunks = 0